import { render, staticRenderFns } from "./accident-maladie-pro.html?vue&type=template&id=72ef131a&scoped=true&external"
import script from "./accident-maladie-pro.js?vue&type=script&lang=js&external"
export * from "./accident-maladie-pro.js?vue&type=script&lang=js&external"
import style0 from "./accident-maladie-pro.scss?vue&type=style&index=0&id=72ef131a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ef131a",
  null
  
)

export default component.exports